"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoryChildren = exports.hasChildren = exports.getCategoryName = void 0;
/**
 * Return category's name translated (if it has translation) or the default category name
 * @param  {Category} category - category obj
 * @param  {string} language - language to be translated
 * @returns {string} translated category name
 */
const getCategoryName = (category, language = 'en') => {
    if (!!category.translations && !!category.translations.names) {
        return !!category.translations.names[language]
            ? category.translations.names[language]
            : category.name;
    }
    return category.name;
};
exports.getCategoryName = getCategoryName;
/**
 * Checks if category has decendents
 * @param  {Category} category - Category obj
 * @returns {boolean} true if category has decendents
 */
const hasChildren = (category) => {
    return !!category.children && !!category.children.length;
};
exports.hasChildren = hasChildren;
/** Return array of child categories from given parent category
 * @param  {Category[]} categories - List of categories objects
 * @param  {Category} category - Parent category to search children
 * @returns {Category[]} Array of children categories
 */
const getCategoryChildren = (categories, category) => {
    if (!(0, exports.hasChildren)(category)) {
        return [];
    }
    return categories.filter((c) => c.parent === category._id);
};
exports.getCategoryChildren = getCategoryChildren;
